import {
  CropType,
  CropTypes,
} from './../../services/entities/impl/blfApi/schemas/variety';

export const REPORT_SUPPORTED_CROP_TYPES: CropType[] = [CropTypes.Blueberries];
